module.exports = __webpack_public_path__ + "static/img/ptx-bg.b169b15.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/ptx-bg.png
// module id = U3Qx
// module chunks = 96